import React from 'react';
import _ from 'lodash';
import { appContext } from '../../util/decorators';
import pubSub from '../../util/pubSub';

@appContext
export default class Notifications extends React.PureComponent {
  static propTypes = {
    notifications: React.PropTypes.array.isRequired,
  };

  componentDidMount() {
    this.embedNotifications(this.props.notifications);
  }

  componentWillReceiveProps({ notifications }) {
    if (_.isEqual(notifications, this.props.notifications)) return;
    this.embedNotifications(notifications);
  }

  isDismissed(id) {
    return localStorage.getItem(`notification_dismissed_${id}`);
  }

  embedNotifications(notifications) {
    let html = '';
    const originalHeight = this.refs.container.clientHeight;

    notifications.forEach(notification => {
      const meta = _.get(notification, 'data.meta', {});
      const link = _.get(notification, 'links.self.href');
      const type = _.get(notification, 'type', '');

      if (this.isDismissed(meta.id)) return;

      html += `
        <div class="notification ${type}" id="notification-${meta.id}">
          <div class="container-fluid notification-content">
            <p>
              ${meta.body}`;

      if (link) html += ` <a href="${link}" target="_blank">${link}</a>`;

      html += `
            </p>
            <button class="close-button" id="notification-${meta.id}-close">
              <i class="icon-x-large"></i>
              <span class="structural">${this.context.app.t('Notifications.close')}</span>
            </button>
          </div>
        </div>
      `;
    });

    this.refs.container.innerHTML = html;

    pubSub.publish('notificationsOffsetChanged', this.refs.container.clientHeight - originalHeight);

    notifications.forEach(notification => {
      const id = _.get(notification, 'data.meta.id');
      if (this.isDismissed(id)) return;
      document.getElementById(`notification-${id}-close`).addEventListener('click', () => this.handleClose(id));
    });
  }

  handleClose(id) {
    const element = document.getElementById(`notification-${id}`);
    const height = element.clientHeight;
    this.refs.container.removeChild(element);
    pubSub.publish('notificationsOffsetChanged', -height);

    try {
      localStorage.setItem(`notification_dismissed_${id}`, true);
    } catch (error) {
      console.log('Did not set notification as dismissed in local storage', error);
    }
  }

  render() {
    return <div ref="container" className="notifications" />;
  }
}



// WEBPACK FOOTER //
// ./src/component/Navigation/Notifications.jsx